import { MAX_PARTS, previewSplit, previewWeights, round2 } from './splitPreview';

// PLA-860 v2: la vista previa del popup debe coincidir con Fractions::SplitFractionService.
describe('previewWeights', () => {
  describe('por sacos', () => {
    it('agrupa sacos y deja el residuo en la ultima subdivision', () => {
      expect(previewWeights(37, 'by_bags', 1, 35)).toEqual([35, 2]);
      expect(previewWeights(700, 'by_bags', 5, 35)).toEqual([175, 175, 175, 175]);
      expect(previewWeights(750, 'by_bags', 5, 70)).toEqual([350, 350, 50]);
    });

    it('no redondea hacia abajo un residuo chico', () => {
      expect(previewWeights(100.2, 'by_bags', 1, 50)).toEqual([50, 50, 0.2]);
    });

    it('sin peso de saco no hay vista previa', () => {
      expect(previewWeights(100, 'by_bags', 1, null)).toEqual([]);
    });

    it('marca la division que supera el tope', () => {
      expect(previewWeights(1000, 'by_bags', 1, 0.1).length).toBeGreaterThan(MAX_PARTS);
    });
  });

  describe('por cantidad de fracciones', () => {
    it('sin peso de saco reparte en partes iguales y la ultima absorbe el redondeo', () => {
      expect(previewWeights(100, 'by_count', 3)).toEqual([33.33, 33.33, 33.34]);
      expect(previewSplit(100, 'by_count', 3).equalPartsFallback).toBe(false);
    });

    // PLA-860 v3 (W1, D2): mismos casos que el plan y que Fractions::SplitFractionService.
    it('reparte sacos enteros equilibrados y la ultima suma el saco incompleto', () => {
      expect(previewWeights(1219, 'by_count', 3, 70)).toEqual([420, 420, 379]);
      expect(previewWeights(1219, 'by_count', 10, 70)).toEqual([
        140, 140, 140, 140, 140, 140, 140, 70, 70, 99,
      ]);
      expect(previewWeights(1400, 'by_count', 6, 70)).toEqual([
        280, 280, 210, 210, 210, 210,
      ]);
      expect(previewWeights(427.29, 'by_count', 4, 70)).toEqual([140, 140, 70, 77.29]);
      expect(previewWeights(100, 'by_count', 3, 7)).toEqual([35, 35, 30]);
    });

    it('con mas partes que sacos completos reparte en partes iguales y lo avisa', () => {
      const preview = previewSplit(427.29, 'by_count', 8, 70);

      expect(preview.weights).toEqual([
        53.41, 53.41, 53.41, 53.41, 53.41, 53.41, 53.41, 53.42,
      ]);
      expect(preview.equalPartsFallback).toBe(true);
    });

    it('suma el peso y las partes difieren en maximo un saco', () => {
      for (let parts = 2; parts <= 17; parts += 1) {
        const weights = previewWeights(1219, 'by_count', parts, 70);
        const bags = [
          ...weights.slice(0, -1).map((weight) => weight / 70),
          (weights[weights.length - 1] - 29) / 70,
        ];

        expect(round2(weights.reduce((total, weight) => total + weight, 0))).toBe(1219);
        bags.forEach((count) => expect(count).toBe(Math.round(count)));
        expect(Math.max(...bags) - Math.min(...bags)).toBeLessThanOrEqual(1);
      }
    });

    it('exige al menos dos partes', () => {
      expect(previewWeights(100, 'by_count', 1)).toEqual([]);
    });
  });
});
